import { isCoverAndCareSchool } from '../themes'

// SAI needs both records in storage before its first render.
export const prepareSchoolLanding = async (axios, { user, schools, selectedSchoolId, token, theme }) => {
  const schoolId = selectedSchoolId || schools?.[0]?.id
  if (theme?.name !== 'Cover and Care' && !isCoverAndCareSchool(schoolId)) return '/dashboard'
  localStorage.removeItem('policyData')
  if (!schoolId || user?.sai !== 1) {
    throw new Error('SAI access is unavailable for this school.')
  }

  const response = await axios.post('v1/staff-hub/policy', {
    token,
    orgId: schoolId,
    user: user.contact_id,
  }, { headers: { Authorization: `Bearer ${token}` } })
  const data = response.data.result?.data
  const policy = data?.policies?.sai
  const org = data?.org
  if (response.data.error === true || !policy?.department || !policy?.policy_id || !org) {
    throw new Error('Unable to load the SAI policy for this school.')
  }
  const organisation = org.trust_name
    ? { type: 'trust', postcode: org.trust_postcode, name: org.trust_name, id: org.trust_id }
    : { type: 'academy', postcode: org.academy_postcode, name: org.academy_name, id: org.academy_id }
  if (!organisation.id) throw new Error('Unable to load the school details.')

  localStorage.setItem('orgType', JSON.stringify(organisation))
  localStorage.setItem('policyData', JSON.stringify(policy))
  localStorage.removeItem('currentPolicy')
  return '/sai/dashboard'
}
